<template>
  <div :class="{ 'mar-top3': showHead }">
    <head-line :line-text="headTitle" v-if="headTitle"></head-line>
    <slot name="filterBox"></slot>
    <div class="hot-main" v-infinite-scroll="loadMore" infinite-scroll-disabled="scrollDisabled" infinite-scroll-immediate-check="false">
      <template v-if="dataList.length > 0">
        <div class="hot-block" :class="{ needItemMarginTop: needItemMarginTop }">
          <div v-for="(item, index) in dataList" :key="item.ProductID">
            <div class="cnt-list-item" v-if="index % 2 === 0" :key="item.ProductID">
              <div class="cnt-list-item-con" @click="entoDetailPage(item.ProductID, item.IsStockNoZero, item.FreeCardNum, index)" @touchstart="itemTouchStart(index)">
                <div class="item-img">
                  <!-- <img v-lazy="item.ShowPicUrl + '!sohoUpyun'" alt="" :key="item.ProductID"/> -->
                  <img v-lazy="item.ShowPicUrl" :data-srcset="item.ShowPicUrl | compressImgUrl" alt="" :key="item.ProductID" />
                  <div class="soldout-mask" v-if="!item.IsStockNoZero && !item.operateMaskShow">
                    <p>Sorry</p>
                    <p>抢光啦</p>
                  </div>
                </div>
                <div class="item-title">
                  <div class="txt">
                    <!-- <span
                      class="platform-tag tm"
                      v-if="item.ShopType.toLocaleUpperCase() === 'B'"
                      >天猫</span
                    >
                    <span
                      class="platform-tag pdd"
                      v-if="item.ShopType.toLocaleUpperCase() === 'P'"
                      >拼多多</span
                    >
                    <span
                      class="platform-tag jd"
                      v-if="item.ShopType.toLocaleUpperCase() === 'J'"
                      >京东</span
                    > -->
                    <plat-formLogo :shopType="item.ShopType.toLocaleUpperCase()"></plat-formLogo>
                    <template>{{ item.TitleShort }}</template>
                  </div>
                </div>
                <div class="item-price">
                  <div class="i-price">
                    <div class="l-prod-price">
                      <div class="price">
                        <div class="yuan">￥</div>
                        <div class="money">
                          {{ item.FreeCardNum !== null ? 0 : item.SaleDiscountPrice }}
                        </div>
                      </div>
                      <div class="through"><span>￥</span>{{ item.ProductPrice || '--' }}</div>
                    </div>
                    <div class="item-tag">
                      <div class="l-freecard-tag" v-if="item.FreeCardNum !== null">
                        <span>免单卡</span>
                        <!-- 新人免单卡数为：1 -->
                        <span>{{ isNewcomer ? 1 : item.FreeCardNum }}</span>
                      </div>
                      <div class="l-rebate-tag">
                        <span class="t">返利</span>
                        <span class="rmb" v-if="item.FreeCardNum !== null">￥{{ item.ProductPrice }}</span>
                        <span class="rmb" v-else-if="item.BuyRebatePrice">￥{{ item.BuyRebatePrice }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 收藏图标 -->
              <!-- <div
                v-if="!item.IsStockNoZero"
                :class="{'remind-icon': true, 'active': item.IsFavorite}"
                @click="remindClick(item.ProductID, item.IsFavorite, index)">
                  <i class="icon iconfont icon-shoucang"></i>
              </div> -->
              <!-- icon -->
              <div class="more-icon" @click="moreIconClick(index)">
                <i class="icon iconfont icon-yuandiancaidan"></i>
              </div>
              <!-- 屏蔽层 -->
              <div v-if="item.operateMaskShow" class="operate-mask opacity-anim" @click.self="item.operateMaskShow = false">
                <div class="operate-icon" @click="remindClick(item.ProductID, item.IsFavorite, index)">
                  <template v-if="!item.IsFavorite">
                    <i class="iconfont icon-icon-test1"></i>
                    <span>收藏</span>
                  </template>
                  <span v-else>取消<br />收藏</span>
                </div>
                <div class="operate-icon mar-t" @click="openShieldDialog(item.ProductID, index)">
                  <i class="iconfont icon-buxihuan"></i>
                  <span>屏蔽</span>
                </div>
              </div>
              <!-- 屏蔽层end -->
            </div>
          </div>
        </div>
        <div class="hot-block" :class="{ needItemMarginTop: needItemMarginTop }">
          <div v-for="(item, index) in dataList" :key="item.ProductID">
            <div class="cnt-list-item" v-if="index % 2 === 1" :key="item.ProductID">
              <div class="cnt-list-item-con" @click="entoDetailPage(item.ProductID, item.IsStockNoZero, item.FreeCardNum, index)" @touchstart="itemTouchStart(index)">
                <div class="item-img">
                  <img v-lazy="item.ShowPicUrl" :data-srcset="item.ShowPicUrl | compressImgUrl" alt="" :key="item.ProductID" />
                  <div class="soldout-mask" v-if="!item.IsStockNoZero && !item.operateMaskShow">
                    <p>Sorry</p>
                    <p>抢光啦</p>
                  </div>
                </div>
                <div class="item-title">
                  <div class="txt">
                    <!-- <span
                      class="platform-tag tm"
                      v-if="item.ShopType.toLocaleUpperCase() === 'B'"
                      >天猫</span
                    >
                    <span
                      class="platform-tag pdd"
                      v-if="item.ShopType.toLocaleUpperCase() === 'P'"
                      >拼多多</span
                    >
                    <span
                      class="platform-tag jd"
                      v-if="item.ShopType.toLocaleUpperCase() === 'J'"
                      >京东</span
                    > -->
                    <plat-formLogo :shopType="item.ShopType.toLocaleUpperCase()"></plat-formLogo>
                    <template>{{ item.TitleShort }}</template>
                  </div>
                </div>
                <div class="item-price">
                  <div class="i-price">
                    <div class="l-prod-price">
                      <div class="price">
                        <div class="yuan">￥</div>
                        <div class="money">
                          {{ item.FreeCardNum !== null ? 0 : item.SaleDiscountPrice }}
                        </div>
                      </div>
                      <div class="through"><span>￥</span>{{ item.ProductPrice || '--' }}</div>
                    </div>
                    <div class="item-tag">
                      <div class="l-freecard-tag" v-if="item.FreeCardNum !== null">
                        <span>免单卡</span>
                        <!-- 新人免单卡数为：1 -->
                        <span>{{ isNewcomer ? 1 : item.FreeCardNum }}</span>
                      </div>
                      <div class="l-rebate-tag">
                        <span class="t">返利</span>
                        <span class="rmb" v-if="item.FreeCardNum !== null">￥{{ item.ProductPrice }}</span>
                        <span class="rmb" v-else-if="item.BuyRebatePrice">￥{{ item.BuyRebatePrice }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- icon -->
              <div class="more-icon" @click="moreIconClick(index)">
                <i class="icon iconfont icon-yuandiancaidan"></i>
              </div>
              <!-- 屏蔽层 -->
              <div v-if="item.operateMaskShow" class="operate-mask opacity-anim" @click.self="item.operateMaskShow = false">
                <div class="operate-icon" @click="remindClick(item.ProductID, item.IsFavorite, index)">
                  <template v-if="!item.IsFavorite">
                    <i class="iconfont icon-icon-test1"></i>
                    <span>收藏</span>
                  </template>
                  <span v-else>取消<br />收藏</span>
                </div>
                <div class="operate-icon mar-t" @click="openShieldDialog(item.ProductID, index)">
                  <i class="iconfont icon-buxihuan"></i>
                  <span>屏蔽</span>
                </div>
              </div>
              <!-- 屏蔽层end -->
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="isFakeData">
        <!-- lazy layout -->
        <div class="lazy-list-item" v-for="item in 4" :key="item">
          <div class="item-img"></div>
          <div class="item-title"></div>
          <div class="item-price"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import HeadLine from '@/components/puppetComponent/HeadLine'
import { Toast, Indicator } from 'mint-ui'
import { mapGetters, mapMutations } from 'vuex'
import { ProductFavoriteAdd, IsSetRemind } from '@/api/remind'
import { IsExistTaskCanAccept } from '@/api/souhuo'

export default {
  data() {
    return {
      // 提醒设置
      isSetting: false,
      curOperateIndex: null
    }
  },
  components: {
    HeadLine
  },
  props: {
    dataList: {
      type: Array,
      require: true,
      default: function() {
        return []
      }
    },
    showHead: {
      type: Boolean,
      default: true
    },
    // 是否展示骨架
    isFakeData: {
      type: Boolean,
      default: false
    },
    // 是否是新人
    isNewcomer: {
      type: Boolean,
      default: false
    },
    headTitle: {
      type: String,
      default: ''
    },
    scrollDisabled: {
      type: Boolean,
      default: false
    },
    needItemMarginTop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getHadShield', 'getIsApp', 'loginState', 'getIsAuthorized'])
  },
  methods: {
    ...mapMutations(['HAD_SHIELD', 'SHIELD_DIALOG_SHOW', 'CUR_PRODUCT_ID', 'AUTHORIZE_POPUP_SHOW']),
    loadMore() {
      this.$emit('loadMore')
    },
    entoDetailPage(productID, isStockNoZero, freeCardNum, index) {
      let isFreeCard = false
      if (freeCardNum !== null) isFreeCard = true
      // this.$emit('entoDetailPage', productID, isStockNoZero, isFreeCard)
      // 存在库存并且已登录的情况
      if (isStockNoZero && this.$store.getters.loginState) {
        Indicator.open({
          text: '加载中',
          spinnerType: 'triple-bounce'
        })
        // 进入前 再次检测是否存在库存
        IsExistTaskCanAccept({ productID: productID })
          .then((res) => {
            Indicator.close()
            if (res.Msg !== 'False') {
              this.$emit('entoDetailPage', productID, isFreeCard)
            } else {
              // 主图变更为被抢光
              this.picAddNoStock(index)
            }
          })
          .catch((res) => {
            Indicator.close()
            if (res.ErrMsg) {
              Toast(res.ErrMsg)
            }
          })
        // 无库存，未登录
      } else {
        this.$emit('entoDetailPage', productID, isFreeCard)
      }
    },
    // 点击其它地方时，关闭上个屏蔽层
    itemTouchStart(index) {
      if (this.curOperateIndex === null) return
      if (this.curOperateIndex !== index && this.dataList[this.curOperateIndex] && this.dataList[this.curOperateIndex].operateMaskShow !== undefined) {
        this.dataList[this.curOperateIndex].operateMaskShow = false
      }
    },
    picAddNoStock(index) {
      Toast('商品已经被抢光啦')
      this.$set(this.dataList[index], 'IsStockNoZero', false)
    },
    async moreIconClick(index) {
      if (!this.$store.getters.loginState) {
        this.unLoginModal()
        return
      }
      this.itemTouchStart(index)
      this.curOperateIndex = index
      const indexIsFavorite = await this.$utils.IsFavorite({
        productId: this.dataList[index].ProductID
      })
      this.$set(this.dataList[index], 'IsFavorite', indexIsFavorite)
      this.$set(this.dataList[index], 'operateMaskShow', true)
    },
    // 打开屏蔽弹窗
    openShieldDialog(productId, index) {
      this.dataList[index].operateMaskShow = false
      this.CUR_PRODUCT_ID(productId)
      this.HAD_SHIELD(false)
      this.SHIELD_DIALOG_SHOW(true)
    },
    // 添加收藏夹/移出收藏夹
    remindClick(productID, isBuyRemind, index) {
      if (!this.loginState) {
        this.unLoginModal()
        return
      }
      if (this.isSetting) return
      this.isSetting = true
      this.dataList[index].operateMaskShow = false
      if (isBuyRemind) {
        // 已设置，点击移出
        Indicator.open({
          text: '移出中',
          spinnerType: 'triple-bounce'
        })
        IsSetRemind({ productId: productID })
          .then((res) => {
            Indicator.close()
            this.isSetting = false
            this.$set(this.dataList[index], 'IsFavorite', false)
            Toast('已移出收藏夹')
          })
          .catch((err) => {
            Indicator.close()
            this.isSetting = false
            Toast(err.ErrMsg)
          })
      } else {
        // 加入收藏夹
        Indicator.open({
          text: '加入收藏中',
          spinnerType: 'triple-bounce'
        })
        ProductFavoriteAdd({ productId: productID })
          .then((res) => {
            Indicator.close()
            this.isSetting = false
            this.$set(this.dataList[index], 'IsFavorite', true)
            Toast('已加入收藏夹')
          })
          .catch((err) => {
            Indicator.close()
            this.isSetting = false
            Toast(err.ErrMsg)
          })
      }
    },
    unLoginModal() {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.$store.commit('LOGINDIALOG_SHOW', true)
    }
  },
  watch: {
    getHadShield() {
      if (this.getHadShield && this.curOperateIndex !== null) {
        this.dataList.splice(this.curOperateIndex, 1)
      }
    }
  },
  filters: {
    compressImgUrl(val) {
      if (/youp-read/g.test(val)) return val + '!sohoUpyun'
      else return val
    }
  }
}
</script>

<style scoped="scoped" lang="scss">
.hot-main {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 2% 0 2%;
  font-size: 14px;
  box-sizing: border-box;
  overflow: hidden;
  background: #f1f1f1;
  background: linear-gradient(to bottom, #fff 0, #f1f1f1 300px, #f1f1f1);
}
.hot-block {
  width: 49%;
}
.needItemMarginTop {
  .cnt-list-item:first-child {
    margin-top: 4%;
  }
}
.cnt-list-item {
  position: relative;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  margin: 0 0 4% 0;
  // border: 1px solid #fefefe;
  background-color: transparent;
  .cnt-list-item-con {
    background-color: #fff;
    width: 100%;
    height: 100%;
  }
}
.cnt-list-item .item-img {
  position: relative;
  overflow: hidden;
}
.cnt-list-item .item-img img {
  display: block;
  width: 100%;
  background: #ffffff;
  min-height: 140px;
}
.cnt-list-item .item-title {
  width: 100%;
  box-sizing: border-box;
  margin: 8px 0 12px;
  padding: 0 4%;
  font-size: 14px;
  color: #333;
  max-height: 6em;
  overflow: hidden;
  text-align: left;
}
.item-title .txt {
  flex-grow: 1;
  max-height: 44px;
  vertical-align: middle;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 22px;
  font-size: 14px;
}
.item-title .tm-icon {
  display: inline-block;
  color: #fff;
  padding: 1px 5px;
  font-size: 12px;
  border-radius: 3px;
  margin-right: 3px;
  background: #f23030;
}
/* price */
.cnt-list-item .item-price {
  width: 100%;
  box-sizing: border-box;
  padding: 0 4% 8px 4%;
  margin-bottom: 1%;
}
.item-price .i-price {
  text-align: left;
  color: #f23030;
}
.flex {
  display: flex;
}
.item-tag {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
/* lazy layout */
.lazy-list-item {
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 49%;
  background: #fff;
  margin-bottom: 3%;
  border-radius: 6px;
}
.lazy-list-item .item-img {
  position: relative;
  width: 100%;
  height: 11em;
}
.lazy-list-item .item-title {
  display: block;
  width: 80%;
  height: 1.2em;
  margin: 4% 4%;
  background: #f5f5f5;
}
.lazy-list-item .item-price {
  width: 50%;
  background: #f5f5f5;
  height: 1.2em;
  margin-bottom: 6%;
  margin-left: 4%;
}
/* 收藏图标 */
/* .remind-icon{
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 4%;
    bottom: 3%;
    color: #999;
    background: #DEDEDE;
    border-radius: 50%;
  }
  .remind-icon:active{
    opacity: 0.8;
  }
  .remind-icon.active{
    color: #FF6700;
    background: #FFE8D7;
  } */
/* 更多icon */
.more-icon {
  position: absolute;
  right: 2%;
  bottom: 3%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 35px;
  height: 35px;
  color: #999;
  text-align: end;
  border-radius: 20px;
}
.more-icon .iconfont:active {
  color: #ccc;
}
/* 屏蔽、收藏层 */
.operate-mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.4);
}
.operate-mask .operate-icon {
  height: 45px;
  width: 45px;
  word-break: break-all;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 10px 2px rgba(253, 246, 246, 0.2);
  font-size: 12px;
  user-select: none;
  -webkit-font-smoothing: subpixel-antialiased;
}
.operate-icon:active {
  background: #eee;
}
.operate-icon .iconfont {
  font-size: 18px;
}
.operate-icon.mar-t {
  margin-top: 24px;
}
/* 补贴专区 */
.unsearch_coupons {
  background: red;
  display: inline-block;
  font-size: 12px;
  color: #fff;
  border-radius: 3px;
  padding: 2px 0;
  height: 14px;
  line-height: 14px;
  margin-left: 8px;
}
.unsearch_coupons > span {
  margin: 0 6px;
  display: inline-block;
}
.unsearch_coupons:before {
  content: '';
  display: flex;
  float: left;
  width: 4px;
  height: 6px;
  border-radius: 0 50% 50% 0;
  background: #fff;
  align-items: center;
  margin-top: 4px;
}
.unsearch_coupons:after {
  content: '';
  display: block;
  float: right;
  width: 4px;
  height: 6px;
  border-radius: 50% 0 0 50%;
  background: #fff;
  margin-top: 4px;
}
img[lazy='loading'] {
  width: 100%;
  height: auto;
  background: #fff;
}
@media screen and (max-height: 568px) {
  .cnt-list-item .item-img img {
    height: 100%;
  }
}
</style>
